import React from "react";
import {
  Page,
  Card,
  Button,
  Table,
  TableToolbar,
  Search,
  Box,
  TextButton,
  Badge,
  Text,
  Modal,
  Loader,
  Divider,
  Radio,
  SidePanel,
  CustomModalLayout,
  FormField,
  Cell,
  Layout,
  Image,
  TagList,
  Accordion,
  DatePicker,
  Pagination,
  Tooltip,
  IconButton,
  PopoverMenu
} from '@wix/design-system';

import { ContentFilterSmall, PrintSmall, DeleteSmall, MoreSmall } from '@wix/wix-ui-icons-common';

import { passCsrfToken } from '../../util/helpers'
import axios from 'axios'
import { openPrintWindow, PRINT_WINDOW_CLOSED } from '../utils/printWindow'

class ByDeposit extends React.Component {

  state = {
    labels: this.props.labels,
    page: this.props.page,
    page_limit: this.props.page_limit,
    count_deposits: this.props.count_deposits,
    total_page: this.props.total_page,
    selectedItems: [],
    searchValue: '',
    queryValue: null,
    date: [],
    date_to: null,
    date_from: null,
    loading: false,
    modalDeleteConfirm: false,
    modalDeleteBulkConfirm: false,
    delete_deposit_id: null,
    printedStatus: [],
  };

  componentDidMount = () => {
    passCsrfToken(document, axios);
    this.callRequest('/deposit-filters');
  }

  /* L'impression thermique passe par une fenêtre top-level : l'iframe Wix ne reçoit
     pas les permissions réseau local, QZ Tray y est injoignable (cf. printWindow.js).
     La fenêtre doit être ouverte dans le clic, avant tout appel réseau. */
  openPrintSession = () => {
    const session = openPrintWindow();
    if (!session) {
      this.props.toggleToast(I18n.t('order_list.error_print_popup_blocked'), true);
      return null;
    }
    session.promise.catch((error) => {
      if (error && error.code === PRINT_WINDOW_CLOSED) return; /* fermée par l'utilisateur */
      this.props.toggleToast(I18n.t('order_list.error_print_bulk_label'), true);
    });
    return session;
  };

  printThermal = (requests) => {
    const session = this.openPrintSession();
    if (session) {
      session.send({ protocole: this.props.config.usb_protocole, requests: requests });
    }
  };

  capitalize = (str) => {
    const lower = str.toLowerCase();
    return str.charAt(0).toUpperCase() + lower.slice(1);
  }

  handleSortChange = (sortValue) => {
    this.setState({sortValue}, () => {
        this.callRequest('/deposit-filters');
    });
  };

  handleRemove = (key) => {
    if (key === 'date_to' || key === 'date_from') {
      this.setState({[key]: null}, () => {
        this.callRequest('/deposit-filters?page='+this.state.page+'&limit='+this.state.page_limit);
      });
    } else {
      this.setState({[key]: []}, () => {
        this.callRequest('/deposit-filters?page='+this.state.page+'&limit='+this.state.page_limit);
      });
    }
  };

  handleChangePage = (value) => {
    this.setState({
      page: value,
    }, () => {
      this.callRequest('/deposit-filters?page='+this.state.page+'&limit='+this.state.page_limit);
    });
  }

  /* Délai avant de lancer la recherche, en ms. La frappe reste affichée
     immédiatement ; seule la requête est différée. */
  SEARCH_DEBOUNCE_MS = 400;

  handleChangeQueryValue = (e) => {
    const name = e.target.name || 'queryValue';
    const value = e.target.value;

    // Le champ est contrôlé : on met le state à jour à CHAQUE caractère pour
    // que la saisie s'affiche sans latence. Auparavant le debounce était
    // délégué au composant Search (debounceMs), si bien que `value` ne
    // changeait qu'après le délai : à chaque rechargement du tableau, Search
    // réappliquait cette valeur périmée et écrasait les caractères tapés
    // entre-temps — d'où l'impossibilité d'enchaîner la frappe.
    this.setState({ [name]: value });

    // Seul l'appel réseau est différé, et relancé à chaque frappe.
    clearTimeout(this._searchTimer);
    this._searchTimer = setTimeout(() => {
      this.callRequest('/deposit-filters?page=1&limit='+this.state.page_limit, true);
    }, this.SEARCH_DEBOUNCE_MS);
  }

  /* Croix de la barre de recherche. Sans ce handler, Search en mode contrôlé
     ne vide ni son affichage ni le state : le champ restait rempli et la
     liste filtrée. */
  handleClearQueryValue = () => {
    clearTimeout(this._searchTimer);
    this.setState({ queryValue: '' }, () => {
      this.callRequest('/deposit-filters?page=1&limit='+this.state.page_limit, true);
    });
  }

  componentWillUnmount = () => {
    clearTimeout(this._searchTimer);
  }

  handleClear = (type) => {
    if (type === 'date') {
      this.setState({
        [type]: [],
        date_to: null,
        date_from: null,
      }, () => {
        this.callRequest('/deposit-filters?page='+this.state.page+'&limit='+this.state.page_limit);
      });
    } else {
      this.setState({
        [type]: [],
      }, () => {
        this.callRequest('/deposit-filters?page='+this.state.page+'&limit='+this.state.page_limit);
      });
    }
  }

  handleClearAll = () => {
    this.setState({loading: true});
    this.setState({
      queryValue: null,
      date: [],
      date_to: null,
      date_from: null,
      printedStatus: [],
    }, () => {
      this.callRequest('/deposit-filters?page='+this.state.page+'&limit='+this.state.page_limit);
    });
  };

  handleSelectionChange = (selectedItems) => {
      this.setState({selectedItems});
  };

  toggleActive = (field) => {
    this.setState({ [field]: !this.state[field] });
  }

  toggleTag = (type, value) => {
    if (type === 'date' || type === 'printedStatus') {
      if (value != 'custom') {
        this.setState({ [type]: [value] }, () =>
          this.callRequest('/deposit-filters?page='+this.state.page+'&limit='+this.state.page_limit)
        );
      } else {
        this.setState({ date_to: null });
        this.setState({ date_from: null });
        this.setState({ [type]: [value] });
      }
    } else {
      if (this.state[type].some((tag) => tag === value)) {
        this.setState({
          [type]: this.state[type].filter(item => item !== value)
        }, () =>
          this.callRequest('/deposit-filters?page='+this.state.page+'&limit='+this.state.page_limit)
        );
      } else {
        this.setState({
          [type]: [...this.state[type], value]
        }, () =>
          this.callRequest('/deposit-filters?page='+this.state.page+'&limit='+this.state.page_limit)
        );
      }
    }
  };

  handleChange = (field) => {
    const includeFilters = [
      'queryValue',
      'date',
      'date_from',
      'date_to'
    ];

    return (value) => {
      this.setState({ [field]: value }, () => {
        if (includeFilters.indexOf(field) !== -1) {
          if (Array.isArray(value)) {
            if (value[0] == "custom") {
              return true;
            }
          }
          this.callRequest('/deposit-filters?page='+this.state.page+'&limit='+this.state.page_limit);
        };
      });
    };
  };

  handleOpenSheet = (deposit_id, deposit_number) => {
      this.getOrderRequest(deposit_id, deposit_number);
  };

  handleCloseSheet = () => {
    this.setState({sheetActive: false});
    this.setState({filterSide: false});
    this.props.handleSheetDepositChange(false);
  };

  handleToggleSheet = (deposit_id, deposit_number) => {
    this.props.sheetActive ? this.handleCloseSheet() : this.handleOpenSheet(deposit_id, deposit_number);
  }

  disambiguateLabel = (key, value) => {
    const options = {
        year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric', second: 'numeric',
        hour12: false,
        timeZone: this.props.shop.time_zone
    };

    switch (key) {
      case 'printedStatus':
        switch (value[0]) {
          case true:
            return `${I18n.t('deposit_list.filters.printed')}`;
          case false:
            return `${I18n.t('deposit_list.filters.unprint')}`;
          default:
            return null;
        }
      case 'date':
        switch (value[0]) {
          case 'past_day':
            return `${I18n.t('order_list.filters.date_today')}`;
          case 'past_week':
            return `${I18n.t('order_list.filters.date_past_week')}`;
          case 'past_month':
            return `${I18n.t('order_list.filters.date_past_month')}`;
          case 'past_quarter':
            return `${I18n.t('order_list.filters.date_past_quarter')}`;
          case 'past_year':
            return `${I18n.t('order_list.filters.date_past_year')}`;
          default:
            return null;
        }
      case 'date_from':
        return `${I18n.t('order_list.filters.date_from')} ${new Intl.DateTimeFormat('default', options).format(new Date(value))}`;
      case 'date_to':
        return `${I18n.t('order_list.filters.date_to')} ${new Intl.DateTimeFormat('default', options).format(new Date(value))}`;
      default:
        return value;
    }
  };

  /* Get order detail */
  getOrderRequest = (deposit_id, deposit_number) => {
    this.setState({loading: true});
    axios({
      method: 'post',
      url: '/get-order-by-deposit',
      data: {
        deposit_id: deposit_id,
        instance_id: this.props.shop.instance_id
      }
    }).then(result => {
      var deposit = {};
      deposit.number = deposit_number;
      deposit.labels= result.data;
      this.props.handleDepositChange(deposit);
      this.setState({loading: false});
      this.props.handleSheetDepositChange(true);
    }).catch(error => {
      console.log(error);
      this.setState({loading: false});
    });
  }

  /* Filter order */
  callRequest = (url = '/deposit-filters', silent = false) => {
    // `silent` : rafraîchissement discret, sans la modale de chargement.
    // Cette modale capte le focus du navigateur ; ouverte pendant une
    // recherche, elle le retirait du champ à chaque requête et rendait la
    // frappe impossible à enchaîner.
    $('html, body').animate({scrollTop: 0}, 10);
    if (!silent) { this.setState({loading: true}); }
    axios.get(url, {
      params: {
        queryValue: this.state.queryValue,
        date: this.state.date,
        date_from: this.state.date_from,
        date_to: this.state.date_to,
        printedStatus: this.state.printedStatus,
        instance_id: this.props.shop.instance_id
      },
    }).then(result => {
      this.setState({labels: result.data.labels});
      this.setState({page: result.data.page});
      this.setState({page_limit: result.data.page_limit});
      this.setState({total_page: result.data.total_page});
      this.setState({count_deposits: result.data.count_deposits});
      if (!silent) { this.setState({loading: false}); }
    }).catch(error => {
        console.log(error);
        if (!silent) { this.setState({loading: false}); }
    });
  }

  printLabelOfDeposit = (id) => {
    if (this.props.showToast) {
      this.props.toggleToast();
    }

    if (this.props.config.use_thermal_printer != true) {
      window.open('/print-labels-by-deposit/'+id+'/'+this.props.shop.instance_id, '_blank');
      return;
    }

    /* La fenêtre d'impression doit être ouverte pendant le clic, donc avant de
       demander au serveur les étiquettes du dépôt. */
    const session = this.openPrintSession();
    if (!session) {
      return;
    }

    /* We retrieve label in deposit */
    axios({
      method: 'post',
      url: '/get_labels_by_deposit',
      data: {
        deposit_id: id,
        instance_id: this.props.shop.instance_id
      }
    }).then(result => {
      if (result.data.success != true || !result.data.label_ids || !result.data.label_ids.length) {
        session.cancel(I18n.t('order_list.error_print_bulk_label'));
        this.props.toggleToast(I18n.t('order_list.error_print_bulk_label'), true);
        return;
      }

      session.send({
        protocole: this.props.config.usb_protocole,
        requests: result.data.label_ids.map((item) => '/deposit-print-bulk-label/'+item+'/'+this.props.shop.instance_id)
      });
    }).catch(error => {
      console.log(error);
      session.cancel(I18n.t('order_list.error_print_bulk_label'));
      this.props.toggleToast(I18n.t('order_list.error_print_bulk_label'), true);
    });
  }

  printDeposit = (id) => {
    if (this.props.showToast) {
      this.props.toggleToast();
    }
    this.printThermal(['/colissimo-label/'+id+'/'+this.props.shop.instance_id]);
  };

  printBulkDeposit = () => {
    if (this.props.showToast) {
      this.props.toggleToast();
    }
    const items = this.state.selectedItems;
    window.open('/deposit-bulk-print/'+items+'/'+this.props.shop.instance_id,'_blank');
    this.setState({loading: false});
  };

  reinitVars = () => {
    this.setState({modalDeleteConfirm: false});
    this.setState({modalDeleteBulkConfirm: false});
    this.setState({delete_deposit_id: null});
  }

  deleteDepositConfirm = (label_id) => {
    this.setState({delete_deposit_id: label_id});
    this.setState({modalDeleteConfirm: true});
  }

  deleteBulkDepositConfirm = () => {
    this.setState({modalDeleteBulkConfirm: true});
  }

  deleteDepositBulk = () => {
    if (this.props.showToast) {
      this.props.toggleToast();
    }
    this.setState({loading: true});
    this.setState({modalDeleteBulkConfirm: false});
    axios({
      method: 'post',
      url: '/delete-deposit-bulk',
      data: {
        deposit_ids: this.state.selectedItems,
        instance_id: this.props.shop.instance_id
      }
    }).then(result => {
      this.setState({loading: false});
      if (result.data.success == true) {
        this.props.toggleToast(I18n.t('deposit_list.success_delete_deposit'), false);
      } else {
        this.props.toggleToast(I18n.t('deposit_list.error_delete_deposit'), true);
      }
      this.setState({selectedItems: []});
      this.callRequest('/deposit-filters');
    }).catch(error => {
      console.log(error);
      this.setState({loading: false});
      this.props.toggleToast(I18n.t('deposit_list.error_delete_deposit'), true);
    });
  }

  actionDeleteDeposit = (deposit_id) => {
    if (this.props.showToast) {
      this.props.toggleToast();
    }
    this.setState({loading: true});
    this.setState({modalDeleteConfirm: false});
    axios({
      method: 'post',
      url: '/delete-deposit-by-id',
      data: {
        deposit_id: deposit_id,
        instance_id: this.props.shop.instance_id
      }
    }).then(result => {
      this.setState({loading: false});
      if (result.data.success == true) {
        this.props.toggleToast(I18n.t('deposit_list.success_delete_deposit'), false);
      } else {
        this.props.toggleToast(I18n.t('deposit_list.error_delete_deposit'), true);
      }
      this.setState({selectedItems: []});
      this.callRequest('/deposit-filters');
    }).catch(error => {
      console.log(error);
      this.setState({loading: false});
      this.props.toggleToast(I18n.t('deposit_list.error_delete_deposit'), true);
    });
  }

  displayModalDeleteDeposit = () => {
    return (
      <Modal
        isOpen={this.state.modalDeleteConfirm}
        onRequestClose={() => this.reinitVars()}
        shouldCloseOnOverlayClick
        screen="desktop"
      >
        <CustomModalLayout
            primaryButtonText={I18n.t('deposit_list.modal.button_confirm')}
            secondaryButtonText={I18n.t('deposit_list.modal.cancel_button')}
            onCloseButtonClick={() => this.reinitVars()}
            secondaryButtonOnClick={() => this.reinitVars()}
            primaryButtonOnClick={() => this.actionDeleteDeposit(this.state.delete_deposit_id)}
            title={I18n.t('deposit_list.modal.delete_deposit_title')}
            content={
              <Box direction="vertical" marginBottom="SP2">
                <Text>{I18n.t('deposit_list.modal.delete_deposit_message')}</Text>
              </Box>
            }
        ></CustomModalLayout>
      </Modal>
    );
  }

  displayModalDeleteBulkDeposit = () => {
    return (
      <Modal
        isOpen={this.state.modalDeleteBulkConfirm}
        onRequestClose={() => this.reinitVars()}
        shouldCloseOnOverlayClick
        screen="desktop"
      >
        <CustomModalLayout
            primaryButtonText={I18n.t('deposit_list.modal.button_confirm')}
            secondaryButtonText={I18n.t('deposit_list.modal.cancel_button')}
            onCloseButtonClick={() => this.reinitVars()}
            secondaryButtonOnClick={() => this.reinitVars()}
            primaryButtonOnClick={() => this.deleteDepositBulk()}
            title={I18n.t('deposit_list.modal.delete_deposit_bulk_title')}
            content={
              <Box direction="vertical" marginBottom="SP2">
                <Text>{I18n.t('deposit_list.modal.delete_deposit_bulk_message')}</Text>
              </Box>
            }
        ></CustomModalLayout>
      </Modal>
    );
  }

  renderColumnLabelNumber = (row) => {
    const {id, number, created_at} = row;

    const options = {
      year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', second: 'numeric',
      hour12: false,
      timeZone: this.props.shop.time_zone
    };

    return (
      <div>
        <Box gap="SP1" verticalAlign="middle">
          <TextButton onClick={(e) => this.handleToggleSheet(id, number)}>#{number}</TextButton>
        </Box>
        <Box>
          <Text size="tiny" skin="disabled">{new Intl.DateTimeFormat('default', options).format(new Date(created_at))}</Text>
        </Box>
      </div>
    );
  }

  renderColumnOrderNumber = (row) => {
    const {nb_parcel} = row;

    return (
      <div>
        <Box gap="SP1" verticalAlign="middle">
          <Badge skin="standard" className="rounded">{nb_parcel}</Badge>
        </Box>
        <Box>
          <Text size="tiny" skin="disabled">{I18n.t('deposit_list.number_of_label')}</Text>
        </Box>
      </div>
    );
  }

  renderColumnPrint = (row) => {
    const {print_at} = row;

    return (
      <div>
        <Box align="center">
            {print_at !== null && <Badge skin="success" size="tiny">
                {I18n.t('deposit_list.printed')}
            </Badge>}
            {print_at === null && <Badge skin="danger" size="tiny">
              {I18n.t('deposit_list.unprinted')}
            </Badge>}
        </Box>
      </div>
    );
  }

  renderColumnActions = (row) => {
    const {id} = row;

    return (
      <div>
          <Button
            priority="secondary"
            size="small"
            prefixIcon={<PrintSmall />}
            as="a" href={`/deposit-print/${id}/${this.props.shop.instance_id}`} target="_blank"
          >
            {I18n.t('order_list.print')}
          </Button>
          &nbsp;
        <PopoverMenu
            textSize="small"
            triggerElement={
              <Tooltip content={I18n.t('order_list.more_actions')}>
                <IconButton priority="secondary" size="small">
                  <MoreSmall />
                </IconButton>
              </Tooltip>
            }
          >
            <PopoverMenu.MenuItem
              text={I18n.t('deposit_list.print_label_of_deposit')}
              prefixIcon={<PrintSmall />}
              onClick={(e) => this.printLabelOfDeposit(id)}
            />
            <PopoverMenu.MenuItem
              text={I18n.t('deposit_list.delete_label')}
              skin="destructive"
              prefixIcon={<DeleteSmall />}
              onClick={(e) => this.deleteDepositConfirm(id)}
            />
        </PopoverMenu>
      </div>
    );
  }

  render() {
    const {
      labels,
      loading,
      filterSide,
      modalDeleteConfirm,
      modalDeleteBulkConfirm,
      queryValue
    } = this.state;

    const columns = [
      {
        title: I18n.t('deposit_list.deposit_number'),
        render: (row) => this.renderColumnLabelNumber(row),
        width: 100
      },
      {
        title: I18n.t('deposit_list.order_number'),
        render: (row) => this.renderColumnOrderNumber(row),
        width: 260
      },
      {
        title: I18n.t('order_list.print_status_label'),
        render: (row) => this.renderColumnPrint(row),
        width: 80,
        align: 'center'
      },
      {
        title: I18n.t('order_list.actions'),
        render: (row) => this.renderColumnActions(row),
        width: 220,
        align: 'center'
      }
    ];

    const includeFilters = [
      'queryValue',
      'date',
      'date_from',
      'date_to',
      'printedStatus'
    ];

    const PrintedFilter = [
      {
        label: I18n.t('deposit_list.filters.printed'),
        value: true,
      },
      {
        label: I18n.t('deposit_list.filters.unprint'),
        value: false,
      },
    ];

    const appliedFilters = Object.keys(this.state)
      .filter((key) => !isEmpty(this.state[key]) && includeFilters.indexOf(key) !== -1)
      .map((key) => {
        return {
        id: key,
        value: this.state[key],
        type: key,
        children: this.disambiguateLabel(key, this.state[key]),
        };
    });

    const tagExists = ({ type, value }) =>
      this.state[type].some((tag) => tag === value)


    const dateFilter = [
      {label: I18n.t('order_list.filters.date_today'), value: 'past_day'},
      {label: I18n.t('order_list.filters.date_past_week'), value: 'past_week'},
      {label: I18n.t('order_list.filters.date_past_month'), value: 'past_month'},
      {label: I18n.t('order_list.filters.date_past_quarter'), value: 'past_quarter'},
      {label: I18n.t('order_list.filters.date_past_year'), value: 'past_year'},
      {label: I18n.t('order_list.filters.date_custom'), value: 'custom'},
    ];

    const paginationMarkup =
      this.props.total_page > 1 ? (
      <Pagination
        currentPage={this.state.page}
        totalPages={this.props.total_page}
        onChange={(e) => this.handleChangePage(e.page)}
      />
  ) : null;

    const emptyStateMarkup = !labels.length ? (
      <Card className="notroundedTop">
      <Table.EmptyState
        subtitle={<Box direction="vertical" paddingTop="SP2">
          <Box><br/></Box>
          <Box align="center"><Text weight="bold">{I18n.t('emptystate.deposit.title')}</Text></Box>
          <Box align="center">{I18n.t('emptystate.deposit.text1')}</Box>
        </Box>}
        image={
          <Image
            height={226}
            width={226}
            src="https://cdn.prod.website-files.com/64a7e3393036f38e45a4c0cc/69a99e69a50f0e7ffa5c1805_BordereauxDexp_226.svg"
            transparent
          />
        }
      >
        <Button as="a" href="https://loom.com/share/folder/c13b118bcbe94b7f8dde5926bacfae92" target="_blank">{I18n.t('emptystate.link_text')}</Button>
      </Table.EmptyState></Card>
    ) : undefined;

    return (
      <div>
        <Modal
          screen="desktop"
          isOpen={loading}
        >
          <Loader size="large" />
        </Modal>

        <Table
          data={labels}
          columns={columns}
          horizontalScroll
          stickyColumns={2}
          showSelection
          onSelectionChanged={this.handleSelectionChange}
          selectedIds={this.state.selectedItems}
        >
          <Page.Sticky>
            <Card className="notrounded">
              <TableToolbar>
                {this.state.selectedItems.length > 0 &&
                  <TableToolbar.ItemGroup position="start">
                    <TableToolbar.Item>
                      <Box gap="12px">
                        <Box gap="3px">
                          <Text size="small" weight="bold">
                            {this.state.selectedItems.length} {I18n.t('order_list.resources_items_orders_title')} {I18n.t('order_list.selected')}
                          </Text>
                          <Text size="small">{I18n.t('order_list.on_total')} {this.state.labels.length}</Text>
                        </Box>
                      </Box>
                    </TableToolbar.Item>
                    <TableToolbar.Item>
                      <Box height="18px">
                        <Divider direction="vertical" />
                      </Box>
                    </TableToolbar.Item>
                    <TableToolbar.Item layout="button">
                      <Button
                        skin="inverted"
                        size="small"
                        onClick={(e) => this.printBulkDeposit()}
                        prefixIcon={<PrintSmall />}
                      >
                        {I18n.t('deposit_list.download_bulk_deposit')}
                      </Button>
                    </TableToolbar.Item>
                    <TableToolbar.Item layout="button">
                      <Button
                        skin="inverted"
                        size="small"
                        onClick={(e) => this.deleteBulkDepositConfirm()}
                        prefixIcon={<DeleteSmall />}
                      >
                        {I18n.t('deposit_list.bulk_delete_deposit_note')}
                      </Button>
                    </TableToolbar.Item>
                  </TableToolbar.ItemGroup>
                }
                {this.state.selectedItems.length <= 0 &&
                  <TableToolbar.ItemGroup position="start">
                    <TableToolbar.Item>
                      <TableToolbar.Label>{this.state.labels.length}{I18n.t('order_list.resources_items_orders_title')}</TableToolbar.Label>
                    </TableToolbar.Item>
                  </TableToolbar.ItemGroup>
                }
                <TableToolbar.ItemGroup position="end">
                  <TableToolbar.Item>
                    <Button
                      size="small"
                      priority="secondary"
                      prefixIcon={<ContentFilterSmall />}
                      onClick={(e) => this.toggleActive("filterSide")}
                    >
                      {I18n.t('order_list.filters.filters')} (2)
                    </Button>
                  </TableToolbar.Item>
                  <TableToolbar.Item>
                    <Search name="queryValue" size="small" value={queryValue} onChange={this.handleChangeQueryValue} onClear={this.handleClearQueryValue}/>
                  </TableToolbar.Item>
                </TableToolbar.ItemGroup>
              </TableToolbar>
              <Table.Titlebar />
              <Table.SubToolbar>
                <Box verticalAlign="middle" width="100%" align="space-between">
                  <Box gap="12px" verticalAlign="middle">
                    <Text size="small">{I18n.t('order_list.filters.filter_by')}</Text>
                    <TagList
                      tags={appliedFilters}
                      actionButton={{
                        label: I18n.t('order_list.filters.clear_all'),
                        onClick: () => this.handleClearAll(),
                      }}
                      onTagRemove={(e) => this.handleRemove(e)}
                    />
                  </Box>
                </Box>
              </Table.SubToolbar>
            </Card>
          </Page.Sticky>
          <Table.Content titleBarVisible={false}/>
          {emptyStateMarkup}
        </Table>
        <br/>
        <Layout justifyItems="center">
          <Cell>
            {paginationMarkup}
          </Cell>
        </Layout>
        <Box>
          <div
            style={{
              position: 'fixed',
              top: 0,
              right: `${filterSide ? 0 : -440}px`,
              display: `${filterSide ? 'block' : 'none'}`,
              height: '100%',
              boxShadow:
                '0 3px 24px 0 rgba(22, 45, 61, 0.18), 0 8px 8px 0 rgba(22, 45, 61, 0.12)',
              transition: 'right 0.4s ease 0s',
              zIndex: 2000,
            }}
          >
            <SidePanel title="Filter" onCloseButtonClick={() => this.handleCloseSheet()}>
              <SidePanel.Header title={I18n.t('order_list.filters.filters')} />
              <SidePanel.Content className="Nopadding">
              <Accordion
                skin="light"
                hideShadow
                size="small"
                items={[
                  {
                    title: I18n.t('order_list.filters.printedStatus'),
                    children: (
                      <Box direction="vertical" gap="12px">
                        {PrintedFilter.map((value, key) => (
                          <Radio
                            checked={tagExists({
                              type: 'printedStatus',
                              value: value.value,
                            })}
                            onChange={(e) => this.toggleTag('printedStatus', value.value)}
                            label={value.label}
                          />
                        ))}
                        <TextButton size="small" onClick={(e) => this.handleClear('printedStatus')}>{I18n.t('order_list.filters.clear')}</TextButton>
                      </Box>
                    ),
                  },
                  {
                    title: I18n.t('order_list.filters.date'),
                    children: (
                      <Box direction="vertical" gap="12px">
                        {dateFilter.map((value, key) => (
                          <Radio
                            checked={tagExists({
                              type: 'date',
                              value: value.value,
                            })}
                            onChange={(e) => this.toggleTag('date', value.value)}
                            label={value.label}
                          />
                        ))}
                        {this.state.date[0] == 'custom' &&
                          <Box direction="vertical">
                            <FormField label={I18n.t('order_list.filters.date_from')}>
                              <DatePicker placeholderText="Date" size="medium" width="240px" value={this.state.date_from} onChange={this.handleChange('date_from')} />
                            </FormField>
                            <FormField label={I18n.t('order_list.filters.date_to')}>
                              <DatePicker placeholderText="Date" size="medium" width="240px" value={this.state.date_to} onChange={this.handleChange('date_to')} />
                            </FormField>
                          </Box>
                        }
                        <TextButton size="small" onClick={(e) => this.handleClear('date')}>{I18n.t('order_list.filters.clear')}</TextButton>
                      </Box>
                    ),
                  },
                ]}
              />
              </SidePanel.Content>
              <SidePanel.Footer>
                <Box gap="12px" paddingBottom="SP4">
                  <Text size="small">{appliedFilters.length} {I18n.t('order_list.filters.filters_applied')}</Text>
                  <TextButton size="small" onClick={(e) => this.handleClearAll()}>{I18n.t('order_list.filters.clear_all')}</TextButton>
                </Box>
                <Button priority="secondary" onClick={(e) => this.handleCloseSheet()} fullWidth>
                  {I18n.t('order_list.filters.close')}
                </Button>
              </SidePanel.Footer>
            </SidePanel>
          </div>
        </Box>
        {modalDeleteConfirm ? this.displayModalDeleteDeposit() : null}
        {modalDeleteBulkConfirm ? this.displayModalDeleteBulkDeposit() : null}
      </div>
    );
  }
}

function isEmpty(value) {
  if (Array.isArray(value)) {
      if (value[0] == "custom") {
          return true;
      }
      return value.length === 0;
  } else {
      /* Add specific Hack for custom value */
      return value === '' || value == null;
  }
}
export default ByDeposit
